import { render, staticRenderFns } from "./DataListLetters.vue?vue&type=template&id=45118a89&"
import script from "./DataListLetters.vue?vue&type=script&lang=js&"
export * from "./DataListLetters.vue?vue&type=script&lang=js&"
import style0 from "./DataListLetters.vue?vue&type=style&index=0&id=45118a89&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports